import { useCallback } from "react";
import { useTranslation } from "next-i18next";

/**
 * Gets request access list of steps.
 * @returns an object with two methods to get steps lists for current and new customers.
 */
export function useGetStepsList() {
  const { t } = useTranslation();

  // Method to get steps list for the current customer
  const getStepsList = useCallback(
    function getStepsList(appRefName: string) {
      const stepsList = [];
      stepsList.push(t("request_access:employee_access.portal_request"));
      stepsList.push(t("request_access:more_information.reason_for_request"));
      if (appRefName === "FIBI") {
        stepsList.push(t("request_access:customer_access.business_unit"));
      }
      stepsList.push(t("request_access:customer_access.contact_information"));
      stepsList.push(t("request_access:customer_access.business_information"));
      stepsList.push(t("request_access:customer_access.request_summary_step"));
      return stepsList;
    },
    [t]
  );

  // Method to get steps list for a new customer
  const getNewCustomerStepsList = useCallback(
    function getNewCustomerStepsList() {
      return [
        t("request_access:employee_access.portal_request"),
        t("request_access:customer_access.contact_information"),
        t("request_access:customer_access.business_information"),
        t("request_access:customer_access.tell_us_more"),
        t("request_access:customer_access.request_summary_step"),
      ];
    },
    [t]
  );

  return { getStepsList, getNewCustomerStepsList };
}
